export class BookingHelper
{
    private static immutableBookingStatuses = ["In Progress", "Completed", "Cancelled", "Auto Cancelled", "No Show"];

    public static isImmutable(bookingStatus: string): boolean
    {
        return BookingHelper.immutableBookingStatuses.includes(bookingStatus);
    }
}
